<template>
    <div>
 <v-card flat>

        <v-card-text style="margin: 0; padding: 0">
            <v-layout justify-start wrap>


                <v-flex xs12 md4 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;">
                    <v-list subheader>
                        <v-subheader style="background: #f0f0f0"> Company Details
                        </v-subheader>
                    </v-list>
                </v-flex>



            </v-layout>
        </v-card-text>
 </v-card>

    </div>
</template>
<script>
export default {
    data: ()=>({
        
    })
}
</script>